<template>
    <wrapper-mobile-bottom-features-wrapper
    showSearchSlot
    :applyHomeRenderDelay="applyHomeRenderDelay"
    @applyLoginLoaderExitAnimation="emit('applyLoginLoaderExitAnimation')">
        <!-- Search slot -->
		<template #top-search-area-slot>
            <header-search @selectHome="emit('selectHome')"/>
		</template>
        <!-- Menu -->
        <div class="meny-body-wrapper">
            <!-- Main Menu -->
            <div class="menu-title">{{t('menu.menu')}}</div>
            <menu-body
            :menuItems="getMenu.filter(obj => obj.additionalData?.menuType !== 'OTHER_OPTIONS' && obj.additionalData?.menuType !== 'HEADER')"
            @clicked="routeHandler"/>
            <!-- Other Options -->
            <div class="menu-title other-options">{{t('menu.otherOptions')}}</div>
            <menu-body :menuItems="getMenu.filter(obj => obj.additionalData?.menuType === 'OTHER_OPTIONS')" @clicked="routeHandler"/>
            <!-- Menu Bottom -->
            <div class="menu-bottom" @click="showConfirmLogoutModal = true">
                <icon-logout/>
                <div class="text-wrapper">
                    <div class="label">{{t('menu.logout')}}</div>
                    <div class="timer">{{t('menu.expiryTime', { timer: getSessionTimer })}}</div>
                </div>
            </div>
        </div>
    </wrapper-mobile-bottom-features-wrapper>
    <!-- Confirm Logout Modal -->
    <modal-centered-generic
    v-if="showConfirmLogoutModal"
    titleIcon="logout"
    rightButtonIcon="check-line"
    :title="t('menu.logoutModal.title')"
    :text="t('menu.logoutModal.text')"
    :rightButtonText="t('menu.logoutModal.leaveButton')"
    @hideMe="showConfirmLogoutModal = false"
    @rightButtonClicked="logoutHandler"/>
    <!-- Loader Generic -->
    <loaders-generic v-if="showOverlayLoader" isOverlay/>
</template>

<script setup>
import WrapperMobileBottomFeaturesWrapper from '@/components/wrappers/featuresTemplates/MobileBottomFeaturesWrapper'
import HeaderSearch from '@/components/generic/navigation/header/Search'
import MenuBody from '@/components/generic/navigation/MenuBody'
import IconLogout from '@/assets/icons/logout.svg?inline'
import LoadersGeneric from '@/components/generic/loaders/Generic'
import ModalCenteredGeneric from '@/components/generic/modals/centered/Generic'
/* Vue */
import { ref, onMounted } from 'vue'
import { navigateByPath } from '@/router/helpers/navigation'
import { getInitialEntry } from '@/assets/scripts/parsers/menu'
/* Store */
import { mapActions, mapGetters } from '@/store/helpers/mappers'
import { moduleMapper } from '@/store/helpers/modules.map'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

/* Emmitters */
const emit = defineEmits(['showCardTypeMenu', 'selectHome', 'applyLoginLoaderExitAnimation'])

/* Props */
const props = defineProps({
    applyHomeRenderDelay: Boolean
})

const { getMenu } = mapGetters(moduleMapper.MENU)
const { logout, forceLogout } = mapActions(moduleMapper.SESSION)
const { getSessionTimer } = mapGetters(moduleMapper.SESSION)

const routeHandler = (menuEntry) => {
    if (menuEntry.childrenAreCardMenuType) emit('showCardTypeMenu', menuEntry)
    else if (menuEntry.firstTabLink) navigateByPath(menuEntry.firstTabLink)
    else if (menuEntry.link === '/home') {
        navigateByPath('/mobileMenuhome')
        emit('selectHome')
    } else navigateByPath(menuEntry.link)
}

const showConfirmLogoutModal = ref(false)
const showOverlayLoader = ref(false)

const logoutHandler = async () => {
    showConfirmLogoutModal.value = false
    showOverlayLoader.value = true

    try {
        await logout()
    } finally {
        forceLogout()
    }
}

onMounted(() => {
    if (getInitialEntry()?.link && props.applyHomeRenderDelay) {
        navigateByPath(getInitialEntry().link)
    }
})
</script>

<style lang="scss" scoped>
.meny-body-wrapper {
    width: 100%;
    padding: 16px 0 0 0;

    .menu-title {
        width: 100%;
        padding: 0 16px;
        margin-bottom: 8px;

        @include H7-Medium;
        color: var(--secondary-dark-3);
        opacity: 0.64;

        &.other-options {
            margin-top: 24px;
        }
    }

    .menu-bottom {
        width: 100%;
        height: 62px;
        padding: 8px 16px 8px 16px;

        display: flex;
        align-items: center;

        border-top: 1px solid var(--secondary-light-2);
        cursor: pointer;

        svg {
            pointer-events: none;
            :deep(.change-color-fill) {
                fill: var(--primary);
            }
        }

        .text-wrapper {
            width: 100%;
            margin-left: 8px;

            color: var(--secondary-dark-2);
            transition: all 0.4s ease-in-out;

            .label {
                width: 100%;
                height: 18px;

                @include H6-Medium;
                line-height: 18px;
            }

            .timer {
                @include H9-Regular;
                opacity: 0.64;
            }
        }
    }
}
</style>
